"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionMatcher = void 0;
var util_1 = require("../common/util");
var class_1 = require("../assets/class");
var RegionMatcher = /** @class */ (function () {
    function RegionMatcher(fragment, regions) {
        this.provinceCode = '';
        this.province = '';
        this.cityCode = '';
        this.city = '';
        this.countyCode = '';
        this.county = '';
        this.codeGroup = '';
        this.nameGroup = '';
        this.gradeGroup = '';
        this.provinces = new Array();
        this.counties = new Array();
        this.cities = new Array();
        // 初始化残缺对象
        this.initFragmentAddress(fragment);
        // 初始化资源数据
        this.initResourceData(regions);
        //
    }
    // 初始化残缺对象
    RegionMatcher.prototype.initFragmentAddress = function (fragment) {
        var _a = fragment.provinceCode, provinceCode = _a === void 0 ? '' : _a, _b = fragment.province, province = _b === void 0 ? '' : _b, _c = fragment.cityCode, cityCode = _c === void 0 ? '' : _c, _d = fragment.city, city = _d === void 0 ? '' : _d, _e = fragment.countyCode, countyCode = _e === void 0 ? '' : _e, _f = fragment.county, county = _f === void 0 ? '' : _f;
        this.provinceCode = provinceCode;
        this.province = province;
        this.cityCode = cityCode;
        this.city = city;
        this.countyCode = countyCode;
        this.county = county;
        this.codeGroup = "" + Number(!!provinceCode) + Number(!!cityCode) + Number(!!countyCode);
        this.nameGroup = "" + Number(!!province) + Number(!!city) + Number(!!county);
        this.gradeGroup = "" + Number(!!(province || provinceCode)) + Number(!!(city || cityCode)) + Number(!!(county || countyCode));
    };
    // 初始化资源数据
    RegionMatcher.prototype.initResourceData = function (regions) {
        var _this = this;
        if (!this.provinces.length || !this.cities.length || !this.counties.length) {
            // 省
            this.provinces = __spreadArrays(Object(regions));
            this.provinces.forEach(function (prov) {
                prov['city'].forEach(function (city) {
                    // 市
                    _this.cities.push(__assign(__assign({}, city), { provinceCode: prov['areaCode'], province: prov['fullName'] }));
                    city['county'] && city['county'].forEach(function (county) {
                        // 区
                        _this.counties.push(__assign(__assign({}, county), { province: prov['fullName'], provinceCode: prov['areaCode'], city: city.fullName, cityCode: city.areaCode }));
                    });
                });
            });
        }
    };
    // 获取查询匹配职责
    RegionMatcher.prototype.getResponsibleChain = function (group) {
        return [{
                match: ~['111', '110', '100', '101'].indexOf(group),
                action: this.matchStartProvince
            }, {
                match: ~['011', '010'].indexOf(group),
                action: this.matchStartCity
            }, {
                match: ~['001'].indexOf(group),
                action: this.matchStartCounty
            }];
    };
    // 补全行政区
    RegionMatcher.prototype.matchRegion = function (expectedCount) {
        var resource = {
            provinces: this.provinces,
            cities: this.cities,
            counties: this.counties
        };
        var fragment = {
            province: this.province,
            city: this.city,
            county: this.county
        };
        var abilities = this.getResponsibleChain(this.gradeGroup);
        var ability = abilities.find(function (item) { return Boolean(item.match); });
        if (!ability)
            return expectedCount === 1 ? {} : [];
        var matches = ability.action.call(this, resource, fragment);
        return expectedCount === 1 ? matches[0] : matches;
    };
    // 省、市、区三级中"省"必有值
    RegionMatcher.prototype.matchStartProvince = function (regions, address) {
        var provinceCode = address.provinceCode, province = address.province, cityCode = address.cityCode, city = address.city, countyCode = address.countyCode, county = address.county;
        var patchedProv = this.getRegion(regions.provinces, { regionCode: provinceCode, regionName: province })[0];
        // 100 类
        if (this.gradeGroup === '100')
            return [new class_1.UserAddressImpl(patchedProv.locationCode, patchedProv.areaCode, patchedProv.fullName)];
        var patchedCity = this.getRegion(patchedProv.city, { regionCode: cityCode, regionName: city })[0];
        var _a = [new Array(), patchedCity.locationCode, patchedCity.areaCode, patchedCity.fullName], counties = _a[0], locationCode = _a[1], cityAreaCode = _a[2], cityName = _a[3];
        // 110 类
        if (this.gradeGroup === '110')
            return [new class_1.UserAddressImpl(locationCode, patchedProv.areaCode, patchedProv.fullName, cityAreaCode, cityName)];
        if (Object.keys(patchedCity).length) {
            // 111 类
            counties = __spreadArrays(patchedCity.county);
        }
        else {
            // 101 类
            patchedProv.city && patchedProv.city.forEach(function (city) { return city.county && city.county.forEach(function (county) { return counties.push(__assign(__assign({}, county), { city: city.fullName, cityCode: city.areaCode })); }); });
        }
        counties = this.getRegion(counties, { regionCode: countyCode, regionName: county });
        // 广东省，深圳市，南山区
        return counties.map(function (county) { return new class_1.UserAddressImpl(county.locationCode, patchedProv.areaCode || county.provinceCode, patchedProv.fullName || county.province, cityAreaCode || county.cityCode, cityName || county.city, county.areaCode, county.fullName); });
    };
    // 省、市、区三级中省无值，"市"必有值
    RegionMatcher.prototype.matchStartCity = function (regions, address) {
        var cityCode = address.cityCode, city = address.city, countyCode = address.countyCode, county = address.county;
        var cityRegion = { regionCode: cityCode, regionName: city };
        var cities = this.getRegion(regions.cities, cityRegion);
        // 010 类
        if (this.gradeGroup === '010') {
            return cities.map(function (city) { return new class_1.UserAddressImpl(city.locationCode, city.provinceCode, city.province, city.areaCode, city.fullName); });
        }
        // 011 类
        var counties = new Array();
        if (cities.length) {
            cities.forEach(function (city) { return city.county && city.county.forEach(function (county) { return counties.push(__assign(__assign({}, county), { province: city.province, provinceCode: city.provinceCode, city: city.fullName, cityCode: city.areaCode })); }); });
        }
        else {
            counties = this.counties;
        }
        counties = this.getRegion(counties, { regionCode: countyCode, regionName: county });
        if (!counties.length) {
            return cities.map(function (city) { return new class_1.UserAddressImpl(city.locationCode, city.provinceCode, city.province, city.areaCode, city.fullName); });
        }
        // ，深圳市，南山区
        return counties.map(function (county) { return new class_1.UserAddressImpl(county.locationCode, county.provinceCode, county.province, county.cityCode, county.city, county.areaCode, county.fullName); });
    };
    // 省、市、区三级中省、市无值，"区"必有值
    RegionMatcher.prototype.matchStartCounty = function (regions, address) {
        var countyCode = address.countyCode, county = address.county;
        var counties = this.getRegion(regions.counties, { regionCode: countyCode, regionName: county });
        return counties.map(function (county) { return new class_1.UserAddressImpl(county.locationCode, county.provinceCode, county.province, county.cityCode, county.city, county.areaCode, county.fullName); });
    };
    RegionMatcher.prototype.getRegion = function (resourceRegions, _a) {
        if (resourceRegions === void 0) { resourceRegions = new Array(); }
        var _b = _a.regionCode, regionCode = _b === void 0 ? '' : _b, _c = _a.regionName, regionName = _c === void 0 ? '' : _c;
        var destRegions;
        if (regionCode)
            destRegions = util_1.exactSearchRegion(resourceRegions, 'areaCode', regionCode);
        if (destRegions)
            return [destRegions];
        if (regionName)
            destRegions = util_1.getRegionsByName(resourceRegions, 'fullName', regionName);
        return destRegions && destRegions.length ? destRegions : [{}];
    };
    return RegionMatcher;
}());
exports.RegionMatcher = RegionMatcher;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/interface-region/dist/patch/matcher.js
// module id = 5vXp
// module chunks = 1